import instObj from '@/backend/axios-instances'

const resource = "/masterproduction"
const instance = instObj.baseInstance

export default {
  get(masterProductionId, parameters) {
    return instance.get(`${resource}/${masterProductionId}`, { params: parameters });
  }
}
